import React, {FC, ReactElement} from 'react';
import {Box, Button, Link, makeStyles, Typography} from '@material-ui/core';
import {strings} from '@constants';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid #e0e3e5',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(5.5),
        '& > *': {
            fontSize: theme.typography.pxToRem(18)
        },
        '&>*:nth-child(1)': {
            textTransform: 'uppercase',
            fontWeight: 600,
            marginBottom: theme.spacing(2)
        },
        '&>*:nth-child(2)': {
            marginBottom: theme.spacing(4)
        },
        '&>*:nth-child(3)': {
            '&>*:nth-child(1)': {
                color: theme.palette.text.black,
                fontSize: theme.typography.pxToRem(18)
            }
        },
        '&>*:nth-child(n+3):nth-child(-n+5)': {
            marginBottom: theme.spacing(2),
            color: theme.palette.text.link
        },
        '&>*:nth-child(6)': {
            marginTop: 'auto',
            textTransform: 'none',
            textDecoration: 'none',

            '&>:first-child': {
                color: theme.palette.text.black,
                borderColor: theme.palette.text.black,
            }
        }
    }
}));

interface SupportTileProps {
    url?: string,
    cols?: number
    rows?: number
    color?: string
}

const SupportTile: FC<SupportTileProps> = ({url = '#', rows = 1, cols = 1, color = 'transparent'}): ReactElement => {
    const classes = useStyles();

    return (
        <Box
            className={classes.root}
            style={{gridColumn: `span ${cols}`, gridRow: `span ${rows}`, backgroundColor: color}}>
            <Typography component="span">{strings.supportContacts}</Typography>
            <Typography component="span">{strings.availability}</Typography>
            <Typography component="span">
                {strings.usPhone}{' '}
                <Typography component="span">{strings.tollFree}</Typography>
            </Typography>
            <Typography component="span">{strings.supportPhone}</Typography>
            <Typography component="span">{strings.email}</Typography>
            <Link href={url} target="_blank">
                <Button variant="outlined">
                    {strings.openTicket}
                </Button>
            </Link>
        </Box>
    );
};

export default SupportTile;
